import { useState, useEffect } from "react";
import { useTheme, useMediaQuery } from '@mui/material';

export const isMobile = (): boolean => {
  if (typeof window === 'undefined') return false;

  const userAgent = window.navigator.userAgent.toLowerCase();
  const mobileKeywords = [
    'mobile',
    'android',
    'iphone',
    'ipad',
    'ipod',
    'blackberry',
    'windows phone',
    'opera mini',
    'iemobile',
  ];

  if (mobileKeywords.some((keyword) => userAgent.includes(keyword))) {
    return true;
  }

  const mobileBreakpoint = 768;
  if (window.innerWidth <= mobileBreakpoint) {
    return true;
  }

  if ('maxTouchPoints' in navigator) {
    return navigator.maxTouchPoints > 0;
  }

  if ('ontouchstart' in window) {
    return true;
  }

  return false;
};  

export const useIsMobile = (): boolean => {
  const theme = useTheme();
  const isMobileBreakpoint = useMediaQuery(theme.breakpoints.down('md'));
  const [isMobileDevice, setIsMobileDevice] = useState(false);

  useEffect(() => {
    setIsMobileDevice(isMobile());
  }, []);

  return isMobileBreakpoint || isMobileDevice;
};

type MobileStateListener = (isMobile: boolean) => void;
const listeners: MobileStateListener[] = [];
let currentMobileState = false;

if (typeof window !== 'undefined') {
  currentMobileState = isMobile();
  window.addEventListener('resize', () => {
    const newMobileState = isMobile();
    if (newMobileState !== currentMobileState) {
      currentMobileState = newMobileState;
      listeners.forEach((listener) => listener(currentMobileState));
    }
  });
}

export const subscribeToMobileStateChanges = (listener: MobileStateListener): (() => void) => {
  listeners.push(listener);

  return () => {
    const index = listeners.indexOf(listener);
    
    if (index !== -1) {
      listeners.splice(index, 1);
    }
  };
};
